import { getFromStorage, setInStorage } from "./storage"


/**
 * Asynchronously adds a product to the cart.
 *
 * @param {string} productId - The ID of the product to add to the cart.
 * @return {Promise} A promise that resolves when the product has been added to the cart.
 * @throws {Error} If the product ID is missing or if there is an error adding the product to the cart.
 */
export const addToCart = async (productId) => {
  if (!productId) {
    console.warn('missing product id to add to cart.')
    return
  }
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          properties: null,
          quantity: 1
        }]
      })
    })
    if (response.status !== 200) {
      console.error('bad request: ', response)
      return null
    }
    setInStorage('show_cart', true, 'session')
  } catch (err) {
    console.error('Error adding to cart: productID: ', productId, ' error: ', err)
  }
  return 'product added to cart'
}
